import './RenderedHelper.scss';
import moment from "moment/moment";
import { t } from 'i18next';

import { classNames } from "primereact/utils";
import { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tooltip } from 'primereact/tooltip';
import { ReactComponent as SuccessIcon } from '../../assets/images/success-icon.svg';
import { ReactComponent as WarningRedIcon } from '../../assets/images/routes/warning-red.svg';
import { ReactComponent as WarningOrangeIcon } from '../../assets/images/routes/warning-orange.svg';
import { FormattedUtils } from '../FormattedUtils';
const iconMap = {
    RouteStatus: {
        PLANNED: 'planned',
        MODIFIED: 'modified',
        CANCELLED: 'deleted',
        IN_PROGRESS: 'in_progress',
        COMPLETED: 'completed',
        TRANSFERRED: 'transferred',
        MERGED: 'merged',
        REASSIGNED: 'reassigned',

    },
    SoftwareUpdateStatus: {
        UPDATED: 'software-update-icon__updated',
        TO_UPDATE: 'software-update-icon__to-update',
    }
}
const routeStatusIconComponentMap = {
    PARTIAL: WarningOrangeIcon,
    NOT_VISITED: WarningRedIcon,
};
const enumColorMap = {
    UserStatus: {
        ACTIVE: 'green',
        INITIALIZED: 'orange',
        INITIALIZED_REMINDER_SENT: 'orange',
        INACTIVE: 'gray',
        REPLACED: 'gray',
        ABSENCE: 'orange',
        DELETED: 'red'
    },
    MerchantStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DELETED: 'red'
    },
    MerchantPrepaidStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DELETED: 'red'
    },
    OperatorStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DELETED: 'red'
    },
    LocationStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DELETED: 'red'
    },
    DeviceStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DELETED: 'red'
    },
    DeviceHealthState: {
        ON_LINE: 'green',
        OFF_LINE: 'red',
        CRITICAL: 'red',
        UNCONFIGURED: 'gray',
        WITH_ERROR: 'orange',
        INACTIVE: 'orange',
        DELETED: 'red',
        UNASSIGNED: 'yellow'
    },
    DebugLogStatus: {
        ENABLE: 'green',
        DISABLE: 'red'
    },
    TerminalHistoryStatus: {
        ASSIGNED: 'green',
        UNASSIGNED: 'red',
        DELETED: 'red',
    },
    TerminalStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DELETED: 'red'
    },
    ProductStatus: {
        ACTIVE: 'green',
        DELETED: 'gray',
        INACTIVE: 'red',
        UNASSIGNED: 'gray'
    },
    ProductTemplateStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DRAFT: 'orange',
        REMOVED: 'red'
    },
    ProductImageStatus: {
        DEFAULT: 'green no-image',
        INDIVIDUAL: 'gray no-image',
    },
    PlanogramStatus: {
        COMPLETED: 'green',
        UNCOMPLETED: 'gray',
        DELETED: 'red',
        DEACTIVATED: 'red'
    },
    RouteStatus: {
        DONE: 'green',
        PLANNED: 'gray',
        MODIFIED: 'orange',
        CANCELLED: 'red',
        IN_PROGRESS: 'orange',
        COMPLETED: 'green',
        TRANSFERRED: 'orange',
        MERGED: 'orange',
        REASSIGNED: 'orange',
        SKIPPED:'red',
        PARTIAL:'orange',
        NOT_VISITED:'red'
    },
    RouteStatusInDeviceDetails: {
        Done: 'green',
        NotStarted: 'gray',
        ComingSoon: 'orange'
    },
    RouteTemplateStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DRAFT: 'orange',
        DELETED: 'red'
    },
    EventPriority: {
        LOW: 'green',
        MEDIUM: 'orange',
        HIGH: 'red'
    },
    EventStatus: {
        ACTIVE: 'green',
        DONE: 'green',
        SKIPPED: 'orange',
        CANCELLED: 'red',
        DIVERGENCE: 'red'
    },
    PlanogramPendingStatus: {
        IN_PROGRESS: 'green',
        PLANNED: 'orange',
        TO_BE_DONE: 'gray',
        COMPLETED: 'green',
        DEPRECATED: 'gray',
        DELETED: 'red'
    },
    TransactionStatus: {
        SUCCESS: 'green',
        FAILED: 'red'
    },
    PaymentStatus: {
        PENDING: 'orange',
        APPROVED: 'green',
        DECLINED: 'red',
        CANCELLED: 'red',
        REFUNDED: 'orange'
    },
    CashLevelStatus: {
        NORMAL: 'green',
        LOW: 'orange',
        OVERFLOW: 'red',
    },
    UserRoleStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DELETED: 'red'
    },
    LocationPriority: {
        LOW: 'green',
        NORMAL: 'orange',
        HIGH: 'red'
    },

    EventConfigStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
        DEACTIVATED: 'red'
    },
    'eventConfig.statuses': {
        ACTIVE: 'green',
        INACTIVE: 'gray',

    },
    ProductConditionStatus: {
        CRITICAL: 'red',
        WARNING: 'orange'
    },
    SlotStatus: {
        LOW: 'orange',
        EMPTY: 'red',
        ENOUGH: 'green'
    },
    TaskStatus: {
        DONE: 'green',
        SKIPPED: 'red',
        ACTIVE: 'orange',
        PLANNED: 'yellow',
        CANCELLED: 'gray'
    },
    SoftwareUpdateStatus: {
        UPDATED: 'green',
        TO_UPDATE: 'orange',
        ERROR: 'red',
        OLD_VERSION: 'gray'
    },
    ImportStatus: {
        NEW: 'green',
        EXISTS: 'orange',
        CONFLICT: 'red',
        INVALID: 'red'
    },
    ReconciliationStatus: {
        APPOINTMENT: "orange",
        AGREED: "green",
        DIVERGENCE: "red"
    },
    ProductCategoryStatus: {
        ACTIVE: 'green',
        DELETED: 'gray',
        INACTIVE: 'red',
    },
    SupplierStatus: {
        ACTIVE: 'green',
        INACTIVE: 'red',
        DELETED: 'gray',
    },
     StockDocumentStatus: {
        DRAFT: 'gray',
        CLOSED: 'green',
    },  
    ImportTemplateStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
    },
    StockLevelStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
    },
    WarehouseStatus: {
        ACTIVE: 'green',
        INACTIVE: 'gray',
    },
};


export const ListWithMore = ({ list, labelResolver }) => {
    const overlayRef = useRef();
    const tooltipTargetIdRef = useRef(
        `list-with-more-box-${Math.random().toString(36).slice(2, 10)}`
    );
    if (!list || list.length === 0) return null;
    const resolveLabel = (item) => labelResolver ? labelResolver(item) : item?.name;
    return (
        <div className='w-full flex flex-row gap-1 justify-content-left align-items-center list-with-more'>
            <div className='flex-1 min-w-0 overflow-hidden white-space-nowrap text-overflow-ellipsis'>
                {list.length > 0 && (<span>{resolveLabel(list[0])}</span>)}
                {list.length > 1 && (
                    <span>, {resolveLabel(list[1]).substring(0, 2)}...</span>
                )}
            </div>
            {list.length > 1 && (
                <>
                    <span
                        id={tooltipTargetIdRef.current}
                        className='flex justify-content-center align-items-center box'
                        onClick={e => overlayRef.current.toggle(e)}
                        data-pr-tooltip={t('multiselect.showAll', 'Show all')}
                        data-pr-position="top"
                        data-pr-classname="tasktype-tooltip"
                    >
                        +{list.length - 1}
                    </span>
                    <Tooltip
                        target={`#${tooltipTargetIdRef.current}`}
                        mouseTrack
                        mouseTrackLeft={60}
                        mouseTrackTop={-45}
                    />
                    <OverlayPanel ref={overlayRef}>
                        <div style={{ minWidth: 120 }}>
                            {list.map((t, idx) => (
                                <div key={idx} className='px-1 py-0'>{resolveLabel(t)}</div>
                            ))}
                        </div>
                    </OverlayPanel>
                </>
            )}
        </div>
    );
};

export const RenderedHelper = {

    formatEnum: (enumValue, enumName, config = {errorCount: 0}) => {

        if (!enumValue) {
            return '';
        }
        const isColored = enumColorMap[enumName] != null;
        const formatLabel = () => t(`${enumName}.${enumValue}`);
        if (isColored) {
            const color = enumColorMap[enumName]?.[enumValue] || 'gray';
            const icon = iconMap[enumName]?.[enumValue] || color;

            const RouteStatusIcon =
                enumName === 'RouteStatus'
                    ? routeStatusIconComponentMap[enumValue]
                    : null;

            return (
                <div className={classNames('status-colored', color)}>
                    {RouteStatusIcon ? (
                        <RouteStatusIcon className='status-image' />
                    ) : (
                        <div className={classNames('status-image', icon)} />
                    )}

                    <div className={classNames('status-name', color)}>
                        {formatLabel()}
                    </div>

                    {config?.errorCount > 0 && (
                        <div className='status-errors'>
                            {config.errorCount}
                        </div>
                    )}
                </div>
            );
        } else {
            return formatLabel();
        }
    },

    formatTimestamp: (utcDate) => {
        if (!utcDate) {
            return '';
        }
        return moment.utc(utcDate).local().format('YYYY-MM-DD HH:mm:ss');
    },

    formatTimestampNoSeconds: (utcDate) => {
        if (!utcDate) {
            return '';
        }
        return moment.utc(utcDate).local().format('YYYY-MM-DD HH:mm');
    },

    formatDate: (utcDate) => {
        if (!utcDate) {
            return '';
        }
        return moment.utc(utcDate).local().format('YYYY-MM-DD');
    },

    formatBoolean: (value) => {
        return t(value ? 'Boolean.true' : 'Boolean.false');
    },

    renderFirstWithMore: (list, label, labelResolver) => {
        return <ListWithMore list={list} label={label} labelResolver={labelResolver} />
    },

    showRouteId: (row) => {
        if (!row) {
            return '---';
        }
        return row.systemId || '---';
    },
    renderSaleGrowth: (growth) => {        
        if (!growth) {
            return (
                <div className='growth-container'>
                    <span className='growth-value'>-</span>
                </div>
            );
        }
        let formattedGrowth = '';
        let color;
        if (growth > 0) {
            color = 'green';
            formattedGrowth = '+';
        } else if (growth < 0) {
            color = 'red';
        } else {
            color = 'gray';
        }
        formattedGrowth += FormattedUtils.formatPrice(growth) + '%';
        return (
            <div className='growth-container'>
                <span className={classNames('growth-value', color)}>{formattedGrowth}</span>
                {growth < 0 && (
                    <div className={classNames('status-colored', color)} style={{ width: 'fit-content' }}>
                        <div className={classNames('status-image', color)} />
                        <div className={classNames('status-name', color)}>{t('salesByLocation.salesDrop')}</div>
                    </div>
                )}
            </div>
        )
    },

    getTaskTypeColor: (taskType) => {
        switch (taskType) {
            case 'DEVICE_ERROR':
                return '#EF4444';
            case 'RESTOCKING':
            case 'PRODUCT_RESTOCKING':
                return '#F97316';
            case 'PRICE_CHANGE':
            case 'PRODUCT_PRICE_CHANGE':
                return '#B53DC2';
            case 'INVENTORY_CHECK':
                return '#EAB308';
            case 'REPLACEMENT':
                return '#3974C5';
            case 'CASH_OPERATION':
                return '#14B8A6';
            case 'MANUAL':
            case 'OTHER':
            default:
                return '#EC4899';
        }
    },

    getTaskTypeBackgroundColor: (taskType) => {
        switch (taskType) {
            case 'DEVICE_ERROR':
                return '#EF444426';
            case 'RESTOCKING':
            case 'PRODUCT_RESTOCKING':
                return '#F9731626';
            case 'PRICE_CHANGE':
            case 'PRODUCT_PRICE_CHANGE':
                return '#B53DC226';
            case 'INVENTORY_CHECK':
                return '#EAB30826';
            case 'REPLACEMENT':
                return '#3974C526';
            case 'CASH_OPERATION':
                return '#14B8A626';
            case 'MANUAL':
            case 'OTHER':
            default:
                return '#EC489926';
        }
    },

    renderTransactionAmount: (amount, typeOfOperation, currency = '') => {
        if (!amount && amount !== 0) {
            return '';
        }
        const type = (typeOfOperation || '').toUpperCase();
        let color = 'gray';
        let sign = '';
        if (type === 'CASH_WITHDRAWAL' || type === 'WITHDRAWAL') {
            color = 'red';
            sign = '-';
        } else if (type === 'CASH_DEPOSIT' || type === 'DEPOSIT' || type === 'SALE') {
            color = 'green';
            sign = '+';
        }
        const formattedAmount = FormattedUtils.formatPrice(amount, currency);
        const colorStyle = {
            color: color === 'red' ? 'var(--accent-red)' : color === 'green' ? 'var(--accent-green)' : 'var(--primary-text-color-dark)'
        }
        return (
            <span style={colorStyle}>
                {sign}{formattedAmount}
            </span>
        );
    },



}